import {
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  ViewContainerRef,
  OnInit,
} from "@angular/core";
import { StrapiMediaComponent } from "../strapi-media/strapi-media.component";
import { StrapiQuoteComponent } from "../strapi-quote/strapi-quote.component";
import { StrapiRichTextComponent } from "../strapi-rich-text/strapi-rich-text.component";

@Component({
  selector: "app-block-resolver",
  template: `<ng-container #container></ng-container>`,
})
export class BlockResolverComponent implements OnInit {
  @Input() block: any;
  @ViewChild("container", { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  private componentMap = {
    "shared.rich-text": StrapiRichTextComponent,
    "shared.quote": StrapiQuoteComponent,
    "shared.media": StrapiMediaComponent,
  };

  constructor(private resolver: ComponentFactoryResolver) {}

  ngOnInit() {
    this.loadComponent();
  }

  loadComponent() {
    const currentBlockType = this.block.__component;
    const componentType = this.componentMap[currentBlockType];

    if (componentType) {
      const factory = this.resolver.resolveComponentFactory(componentType);
      const componentRef = this.container.createComponent(factory);
      if (currentBlockType === "shared.rich-text") {
        (componentRef.instance as any).data = this.block.body;
      } else {
        (componentRef.instance as any).data = this.block;
      }
    }
  }
}
